import { ValidationRuleFunction } from 'vee-validate/dist/types/types';

const required_checkbox: ValidationRuleFunction = value => {
  return value === true;
};
export default required_checkbox;
